import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import StyledButton from "src/components/dashboard/StyledButton";
import { UserInputModal } from "src/components/settings/security/UserInputModal";
import api from "src/store/features/api";
import CustomStepper from "src/components/common/CustomStepper";
import Preloader from "src/utils/Preloader";
import { SmsStyles } from "./styles/smsStyles";
import { trackEvent } from "src/Amplitude";
import { SmsRes } from "src/store/features/api/generated";

type smsStateType = "loading" | "normal" | "success" | "fail" | "wrong code";
export default function SmsPhoneVerification(props: any) {
  const classes = SmsStyles();
  const [smsState, setSmsState] = useState<smsStateType>("normal");
  const [lastTwoDigits, setLastTwoDigits] = useState<string>();
  const [trigger] = api.useLazyCreateSms2FaQuery();

  // In order to make your account more secure, we need to first verify your Mobile Number.
  const messageOne =
    "Click on the button below to receive a code by SMS to account holders mobile number.";

  const successMessage = `A code has been sent to the mobile number ending with ${lastTwoDigits}`;

  const errorMessage = "Something went wrong, please try again";

  const handleClick = () => {
    trackEvent(
      "Button_Click",
      {
        button: "Get a verification code",
      },
      "Sms_Phone_Verification",
    );

    setSmsState("loading");
    trigger()
      .unwrap()
      .then((response: SmsRes) => {
        setSmsState("success");
        setLastTwoDigits(response.phone);
      })
      .catch(() => {
        setSmsState("fail");
      });
  };

  return (
    <Grid container className={classes.container}>
      {smsState !== "fail" && (
        <Grid container item xs={12} py={2}>
          <CustomStepper type={"sms"} activeStep={0} />
        </Grid>
      )}
      {smsState === "normal" && (
        <Grid item xs={12}>
          <Typography mt={2} className={classes.fieldDescription}>
            {messageOne}
          </Typography>
        </Grid>
      )}
      {smsState === "loading" && (
        <Grid item xs={12}>
          <Preloader />
        </Grid>
      )}
      {smsState === "fail" && (
        <Grid item xs={12}>
          <Typography>{errorMessage}</Typography>
        </Grid>
      )}
      {smsState === "normal" && (
        <StyledButton onClick={() => handleClick()}>Get a verification code</StyledButton>
      )}

      {smsState === "success" && (
        <UserInputModal
          message={successMessage}
          isSuccess={true}
          setSmsState={setSmsState}
          setDialogState={props.setDialogState}
        />
      )}
      {smsState === "wrong code" && (
        <UserInputModal
          message={errorMessage}
          isSuccess={false}
          setSmsState={setSmsState}
          setDialogState={props.setDialogState}
        />
      )}
    </Grid>
  );
}
